import styled, { css } from 'styled-components';
import { ICON_SIZES } from '@anwb/icon';
import { getIconUrl, pxToRem } from '@anwb/style-utilities';
import { ANWBDefault } from '@anwb/theme';
import Typography from '@anwb/typography';
const CUSTOM_ICON_OFFSET_TOP = -4;
export const getVariantSpecificStyles = (variant, theme, iconColor, icon) => {
    switch (variant) {
        case 'checked':
            return iconContentStyles('check-usp', 'positive');
        case 'marked':
            return theme.name === ANWBDefault.name
                ? iconContentStyles('cross', iconColor)
                : iconContentStyles('cross', 'error');
        case 'plussed':
            return theme.name === ANWBDefault.name
                ? iconContentStyles('plus', iconColor)
                : iconContentStyles('plus', 'positive');
        case 'minused':
            return theme.name === ANWBDefault.name
                ? iconContentStyles('minus', iconColor)
                : iconContentStyles('minus', 'error');
        case 'inactive':
            return inactiveItemStyles;
        case 'bulleted':
            return bulletedItemStyles;
        case 'numbered':
            return numberedItemStyles;
        default:
            if (icon) {
                return css `
					&::before {
						mask: url('${getIconUrl(icon, 'illustrative')}') no-repeat center right;
					}
				`;
            }
            return null;
    }
};
export const listItemStyles = ({ theme, $variant, $iconColor, $compact, $icon, }) => css `
	margin: 0;
	padding-top: ${pxToRem(theme.spacing[100])};

	${getVariantSpecificStyles($variant, theme, $iconColor, $icon)}

	${!$compact &&
    css `
		&:not(:last-child) {
			margin-bottom: ${pxToRem(theme.paragraphSpacing[300])};
		}
	`}
`;
export const StyledListItem = styled.li `
	${listItemStyles}
`;
export const StyledTypographyListItem = styled(Typography) `
	${listItemStyles}
`;
export const listItemTitleStyles = css `
	display: block;
	margin-bottom: 0;
`;
export const StyledListItemTitle = styled(Typography) `
	${listItemTitleStyles}
`;
const markerStyles = ({ theme }) => css `
	position: relative;
	padding-left: ${pxToRem(theme.spacing[400])};

	&:before {
		font-style: normal;
		font-weight: normal;
		font-variant: normal;
		text-transform: none;
		vertical-align: middle;

		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		-ms-transform: rotate(-0.001deg);

		display: inline-block;
		position: absolute;
		left: 0;
		top: ${pxToRem(theme.spacing[100])};
		line-height: inherit;
	}
`;
const getIconColor = ({ colors }, iconColor) => {
    if (!iconColor)
        return 'currentcolor';
    if (iconColor === 'error')
        return colors.error.iconError;
    return colors.positive.iconCheck;
};
const iconContentStyles = (icon, iconColor) => ({ theme }) => css `
			${markerStyles}

			&:before {
				content: '';
				height: ${pxToRem(ICON_SIZES.sm)};
				width: ${pxToRem(ICON_SIZES.sm)};
				margin-top: ${ANWBDefault.name === theme.name
    ? pxToRem(theme.spacing[100])
    : pxToRem(theme.spacing[50])};
				mask: url('${getIconUrl(icon, 'ui')}') no-repeat center right;
				background-color: ${getIconColor(theme, iconColor)};
			}
		`;
const inactiveItemStyles = ({ theme }) => css `
	position: relative;
	padding-left: ${pxToRem(theme.spacing[400])};
	color: ${theme.name === ANWBDefault.name
    ? theme.colors.medium.textInactive
    : theme.colors.medium.textDisabled};
`;
const bulletedItemStyles = ({ theme }) => css `
	list-style-type: disc;
	margin-left: ${pxToRem(theme.spacing[300])};

	.PONCHO-list--mixed && {
		list-style-type: disc;
		padding-left: ${pxToRem(theme.spacing[100])};
		margin-left: ${pxToRem(theme.spacing[300])};
	}
`;
const numberedItemStyles = ({ theme }) => css `
	list-style-type: decimal;
	margin-left: ${pxToRem(theme.spacing[300])};
`;
export const iconItemStyles = ({ theme }) => css `
	position: relative;
	padding-top: 0;
	margin-top: ${pxToRem(theme.spacing[200])};
	margin-bottom: ${pxToRem(theme.paragraphSpacing[400])};

	&:last-of-type {
		margin-bottom: 0;
	}

	&::before {
		content: '';
		position: absolute;
		top: ${pxToRem(CUSTOM_ICON_OFFSET_TOP)};
		left: 0;
		width: ${pxToRem(ICON_SIZES.xxxl)};
		height: ${pxToRem(ICON_SIZES.xxxl)};
		background-color: ${theme.colors.base.iconIllustrative};
	}
`;
//# sourceMappingURL=list-item.styled.js.map